import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const RequestingPowers = ({ powers }) => {
  if (!powers || powers.length === 0) {
    return (
      <Box sx={{ mt: 4 }}>
        <Paper
          sx={{
            padding: 2,
            backgroundColor: '#f9f9f9',
            borderRadius: 2,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            border: '1px solid #e0e0e0',
          }}
        >
          <Typography variant="h6" sx={{ color: 'text.secondary' }}>
            No powers available.
          </Typography>
        </Paper>
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Paper
        sx={{
          padding: 2,
          backgroundColor: '#f9f9f9',
          borderRadius: 2,
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
          border: '1px solid #e0e0e0',
        }}
      >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold' }}>
          Powers
        </Typography>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Power Number</TableCell>
                <TableCell>Bond Amount</TableCell>
                <TableCell>Execution Date</TableCell>
                <TableCell>Case Number</TableCell>
                <TableCell>Charges</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {powers.map((power, index) => (
                <TableRow key={index}>
                  <TableCell>{power.powerNumber || 'N/A'}</TableCell>
                  <TableCell>
                    {power.bondAmount ? `$${power.bondAmount.toLocaleString()}` : 'N/A'}
                  </TableCell>
                  <TableCell>
                    {power.executionDate
                      ? new Date(power.executionDate).toLocaleDateString()
                      : 'N/A'}
                  </TableCell>
                  <TableCell>{power.caseNumber || 'N/A'}</TableCell>
                  <TableCell>{power.charges || 'N/A'}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default RequestingPowers;
